module.exports = __webpack_public_path__ + "static/media/required.5d8a6e30.png";